exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".certificates-table--container {\n  width: 100%;\n  padding: 0 40px 40px 40px;\n}\n\n.certificates-table--data-grid {\n  margin-top: 16px !important;\n}", ""]);

